import { create, all } from 'mathjs'
import * as functions from './functions'

const math = create(all)

math.import({ ...functions }, { override: true })

export default math
